// Important
window.$ = window.jQuery = require('jquery');
require('popper.js/dist/popper.min');
//window.moment = require('moment');
require('../../modules/vegas/js/functions');

// Project
require('./project/config');
require('./project/dependencies');
require('./project/index');
